<template>
    <div class="d-flex justify-end">
        <v-tooltip bottom>
            <template #activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" :style="{ color: color }" class="hoverable-icon">
                    {{ icon }}
                </v-icon>
            </template>
            <div class="custom-tooltip">
                {{ text }}
            </div>
        </v-tooltip>
    </div>
</template>

<script>
    export default {
        name: 'IconTooltip',
        props: {
            icon: {
                type: String,
                required: true
            },
            text: {
                type: String,
                required: true
            },
            color: {
                type: String,
                default: 'red'
            }
        }
    }
</script>

<style scoped>
.custom-tooltip {
  background-color: #2c2c2c;
  color: #fff;
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 6px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);
  max-width: 200px;
  text-align: center;
}

.hoverable-icon {
  transition: transform 0.2s ease;
}

.hoverable-icon:hover {
  transform: scale(1.2);
  cursor: pointer;
}
</style>
